<template>
    <div class="py-20">
      <div class="flex w-full justify-center">
        <div class="w-full">
          <div class="flex w-full justify-center px-6">
            <div class="flex flex-col md2:flex-row w-full max-w-8xl justify-between gap-y-15 md2:gap-x-2">
              <div class="flex w-full md2:w-fit justify-center md2:justify-normal flex-row md2:flex-col order-3 md2:order-none pt-3 md2:pt-0">


             <div class="flex w-full justify-center text-center items-center font-semibold cursor-pointer md2:mb-2">
               <button
                 :disabled="isAtTop"
                 :class="{ 'opacity-30 disabled:cursor-auto': isAtTop }"
                 class="text-center items-center font-semibold cursor-pointer transition duration-300 ease-in-out group -rotate-90 md2:rotate-0"
                 @click="scrollUp">
                 <svg class="w-10 h-10" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                   <polygon points="50,35 75,60 72,63 50,42 28,63 25,60" class="fill-ihh-midnight-gray group-hover:fill-ihh-gray"/>
                 </svg>
               </button>
             </div>

             <div class="p-1 ease-in-out transition duration-300" v-for="(product, a) in visibleProducts" :key="a">
               <div
                 @click="updateImage(product.image)"
                 @mouseover="updateImage(product.image)"
                 :class="{ 'border-3 border-ihh-midnight-gray': selectedImage === product.image }"
                 class="flex bg-ihh-light-lavendar rounded-xl w-14 h-14 sm:w-20 sm:h-20 md2:w-28 md2:h-28 overflow-hidden items-center p-4 shadow-md cursor-pointer group"
               >
                 <img
                   class="w-full object-center object-cover"
                   :src="product.image"
                   alt="products images"
                 />
               </div>
             </div>

             <div class="flex w-full justify-center text-center items-center font-semibold cursor-pointer md2:mt-2">
               <button
                 :disabled="isAtBottom"
                 :class="{ 'opacity-30 disabled:cursor-not-allowed': isAtBottom }"
                 class="text-center items-center font-semibold cursor-pointer transition duration-300 ease-in-out group -rotate-90 md2:rotate-0"
                 @click="scrollDown">
                 <svg class="w-10 h-10" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                   <polygon points="50,65 75,40 72,37 50,58 28,37 25,40" class="fill-ihh-midnight-gray group-hover:fill-ihh-gray"/>
                 </svg>
               </button>
              </div>
           </div>

              <div class="order-2 md2:order-none w-full justify-center flex md2:block md2:mx-6">
                <div class=" flex w-full max-w-3xl 2xl:ml-4 bg-ihh-light-lavendar rounded-xl items-center p-6 md2:p-12 shadow h-full overflow-hidden min-h-[450px] max-h-[450px] md:min-h-[600px] md:max-h-[600px]">
                    <div class="flex w-full justify-center">
                        <!-- min-h-[400px] max-h-[400px] md2:min-h-[600px] md2:max-h-[600px] -->
                        <!-- max-w-sm min-w-sm md2:max-w-[300px] md2:min-w-[300px] xl:min-w-[500px] xl:max-w-[500px] -->

                        <!-- This image below is the one that when hovered needs to have the zoom  -->
                  <img
                    class="rounded w-full object-center object-cover items-center flex justify-center max-w-sm min-w-sm md2:max-w-[250px] md2:min-w-[250px] xl:min-w-[500px] xl:max-w-[500px]"
                    :src="selectedImage"
                    alt="selected image"
                  />
                  </div>
                </div>
                <div class="w-full justify-start mt-4 hidden md2:flex">
                  <div class="flex mx-4" v-for="feature, i in featured" :key="i">
                    <img
                      :src="feature.image"
                      alt="Features Icons"
                      class="w-5 h-5 mr-1 m-auto"
                    />
                    <div
                      class="m-auto text-start flex w-full justify-start text-ihh-slate-gray text-xs"
                    >
                      {{ feature.title }}
                    </div>
                  </div>
                </div>
              </div>



              <div class="flex w-full justify-center md2:w-fit">
              <div class="space-y-6 py-4 order-1 md2:order-none block md2:hidden w-full max-w-3xl">
                <div
                  class="flex w-full justify-between text-start text-ihh-midnight-gray text-xl md2:text-4xl font-semibold tracking-wide"
                >
                  <span class="pr-20">
                    Birth Pool in a Box Pool Liner - Mini Size
                  </span>
                  <div class="cursor-pointer relative z-10 flex">
                    <div class="w-10 h-8">
                      <div
                        class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-1.5 rounded-md absolute shadow"
                      >
                        <img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
                      </div>
                    </div>
                  </div>
                </div>

                    <div class="flex w-full sm:pb-0 text-sm md2:text-lg flex-col md2:flex-row">
                      <div
                        v-if="selectedQuantity"
                        class="text-ihh-midnight-gray font-normal text-lg sm:text-2xl tracking-wide text-start flex w-full"
                      >
                        {{ productInfo[selectedQuantity - 1].price }}
                        <div class="flex w-full justify-end m-auto">
                          <Stars class=""/>
                          <div
                            class="text-sm text-ihh-slate-gray mx-2 m-auto whitespace-nowrap"
                          >
                            (4.5)
                            <a @click="showReview = true" class="underline text-ihh-dark-salmon hover:text-ihh-salmon hidden">Write a Review</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

            <div class="flex w-full justify-center md2:w-fit md2:justify-around order-4 md2:order-none">
              <div class="space-y-6 py-4 w-full md2:w-fit max-w-3xl md2:max-w-none">
                <div
                  class="flex w-full text-start text-ihh-midnight-gray text-3xl font-semibold tracking-wide hidden md2:flex"
                >
                  <span class="pr-5">
                    Birth Pool in a Box Pool Liner - Mini Size
                  </span>
                  <div class="cursor-pointer relative z-10 flex">
                    <div class="w-10 h-8">
                      <div
                        class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-1.5 rounded-md absolute shadow"
                      >
                        <img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
                      </div>
                    </div>
                  </div>
                </div>


                  <div>
                    <div class="flex w-full sm:pb-0 text-sm md2:text-lg flex-col md2:flex-row hidden md2:flex">
                      <div
                        v-if="selectedQuantity"
                        class="text-ihh-midnight-gray font-normal text-base sm:text-2xl tracking-wide text-start flex flex-col justify-start w-full"
                      >



                      <div class="flex w-full justify-start">
                        <div class="flex-col">
                      <div class="text-base" v-if="productInfo[selectedQuantity - 1].salesPrice">
                             Was:
                        </div>
                <div class=""
                     :class="productInfo[selectedQuantity - 1].salesPrice || productInfo[selectedQuantity - 1].quantity <= 0 ? 'line-through text-ihh-slate-gray/80 text-xl' : 'text-ihh-midnight-gray font-normal text-base sm:text-2xl'">
                         ${{ productInfo[selectedQuantity - 1].price }}
                       </div>
                          <div class="relative hidden z-50 bg-ihh-midnight-gray flex w-full justify-start w-12 h-12" v-if="percentage">
                            <div class="hidden flex-col text-sm bg-ihh-midnight-gray text-ihh-white items-center">
                            <div class="flex w-full justify-center items-center border w-12 h-12 rounded-full">
                                <div class="flex-col">
                                <div class="mr-1">{{ percentage }}%</div><br>
                              <div>off!</div>
                            </div>
                          </div>
                          </div>
                          </div>
                       <div class="" v-if="productInfo[selectedQuantity - 1].salesPrice">
                          ${{ productInfo[selectedQuantity - 1].salesPrice }}
                       </div>
                    </div>
                    <div class="flex w-full justify-end m-auto">
                        <div class="flex flex-col lg:flex-row">
                            <div class="flex w-full justify-end text-xs text-ihh-slate-gray mx-2 font-semibold m-auto whitespace-nowrap">
                                <span class="flex items-center"><Stars class="w-20"/> <span class="ml-1">(4)</span></span>
                          </div>
                          <div
                            class="flex w-full justify-end text-xs text-ihh-slate-gray font-semibold m-auto whitespace-nowrap"
                          >
                            <button @click="showReview = true" class="underline text-ihh-slate-gray hover:text-ihh-dark-salmon">Write a Review</button>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
              </div>
            </div>


                  <div v-if="selectedQuantity" class="">
                    <div class="text-sm text-ihh-slate-gray">
                      <span class="text-ihh-midnight-gray font-semibold mr-1"
                        >UPC:</span
                      >
                      {{ productInfo[selectedQuantity - 1].upcNumbers }}
                    </div>
                    <div class="text-sm text-ihh-slate-gray">
                      <span class="text-ihh-midnight-gray font-semibold mr-1"
                        >Availability:</span
                      >
                      <span
                        :class="[
                          'flex-inline mr-1',
                          { hidden: productInfo[selectedQuantity - 1].quantity <= 0 },
                        ]"
                        >{{ productInfo[selectedQuantity - 1].quantity }}</span
                      >
                      <span>
                        {{
                          productInfo[selectedQuantity - 1].quantity <= 0
                            ? 'Out of stock'
                            : 'left in stock'
                        }}</span
                      >.
                    </div>
                    <div class="text-sm text-ihh-slate-gray">
                      <span class="text-ihh-midnight-gray font-semibold mr-1"
                        >Maximum Purchase:</span
                      >
                      1 unit
                    </div>
                  </div>

                  <div class="">
                    <a href="#details" class="text-xs sm:text-sm font-semibold underline text-ihh-dark-salmon hover:text-ihh-salmon">See details</a>
                  </div>

                  <div class="text-sm text-ihh-slate-gray font-semibold">
                    <span class="text-ihh-midnight-gray mr-2">Quantity:</span>
                    (Required)
                    </div>

                    <div class="flex w-full flex-wrap gap-3">
                       <button
                         v-for="(item, i) in productInfo"
                         :key="i"
                         :class="[
                           'text-sm px-6 border-2 border-gray-300 rounded-lg text-ihh-midnight-gray py-3 overflow-hidden',
                           {
                             'bg-ihh-slate-gray/20 ring ring-black border-0 text-ihh-midnight-gray font-semibold':
                               selectedQuantity === i + 1,
                             'border-ihh-gray/50 bg-ihh-slate-gray/20text-ihh-midnight-gray/80 opacity-70':
                               selectedQuantity !== i + 1,
                             'border-ihh-gray/80 bg-ihh-white border-dashed text-ihh-midnight-gray/80 opacity-60':
                               item.quantity <= 0,
                           },
                         ]"
                         @click="selectPage(i + 1)"
                       >
                         {{ item.packages }}
                         <div class="w-full m-auto items-center justify-center -translate-y-2">
                         <div :class="[
                           'relative flex w-full items-center justify-center',
                           {
                             'rotate-45 flex border-t border-dashed border-red-600 opacity-80 p-px':
                               item.quantity <= 0,
                           },
                         ]"/>
                         <div :class="[
                           'relative flex w-full items-center justify-center',
                           {
                             '-rotate-45 flex border-t border-dashed border-red-600 opacity-80 p-px justify-center items-center':
                               item.quantity <= 0,
                           },
                         ]"/>
                         </div>
                       </button>

                  <div class="flex w-full justify-around gap-x-2 mt-6">
                    <div class="flex w-full justify-start items-center">
                        <div :disabled="isAddToBagDisabled"
                        :class="['flex w-full shadow rounded-xl', { 'cursor-not-allowed': isAddToBagDisabled, },]">
                      <button
                        class="bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray h-full px-4 py-2 text-lg rounded-l-xl"
                      >
                        -
                      </button>
                      <input
                        type="text"
                        class="flex w-full justify-center items-center text-center text-lg text-black px-1 focus:outline-none focus:ring-1 focus:ring-ihh-dark-salmon rounded z-10"
                        value="1"
                      />
                      <button
                        class="bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray h-full px-4 py-2 text-lg rounded-r-xl"
                      >
                        +
                      </button>
                    </div>
                </div>

                <div class="my-1" id="details" />


                <!-- <div
                class="top-[82px] sm:top-[80px] select-none w-full transition-all transform-gpu duration-500 transform-gpu bg-white shadow-lg h-screen fixed left-0 z-40"
                :class="showMenu ? '' : 'translate-y-full'"
                @click.stop
                /> -->

                <button
                  :class="addToBagButtonClass"
                  :disabled="isAddToBagDisabled"
                  v-html="!isAddToBagDisabled ? `Add to Bag` : `Out of Stock`"
                >
                </button>


              </div>

            </div>

            <div
                    v-if="productInfo[selectedQuantity - 1].quantity <= 0"
                    class="flex w-full justify-start bg-ihh-check p-4 rounded mt-4"
                  >
                    <div class="flex mr-4">
                      <img
                        src="/images/ob-alert.svg"
                        alt="option Icons"
                        class="w-8 h-8 p-1 mr-4 m-auto"
                      />
                    </div>
                    <div
                      class="w-full justify-start text-black text-start m-auto"
                    >
                      The selected product is currently unavailable.
                    </div>
                  </div>



                <!-- Fast Shipping, Satisfaction Guarantee, Easy Returns -->
                    <div class="flex w-full justify-between">
                      <div
                        class="flex w-fits justify-around"
                        v-for="option, i in options"
                        :key="i"
                      >
                        <div class="flex">
                          <img
                            :src="option.image"
                            alt="Features Icons"
                            class="w-8 h-8 bg-ihh-white shadow-md rounded p-1 m-auto mr-2"
                          />
                          <div
                            class="text-start text-ihh-midnight-gray text-sm font-semibold"
                          >
                            {{ option.title }}
                          </div>
                        </div>
                      </div>
                    </div>


                </div>
              </div>
            </div>
        </div>
         <div class="flex w-full justify-center px-3 mt-12">
           <div class="flex w-full max-w-3xl md2:max-w-8xl gap-x-4">
             <!-- Description Button -->
             <button
               @click="setActive('description')"
               :class="[
                 'text-center flex w-full justify-center py-3.5 px-2 border border-slate-100 rounded-lg text-description font-semibold shadow-md tracking-wide',
                 activeSection === 'description'
                   ? 'bg-ihh-midnight-gray text-white'
                   : 'bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray',
               ]"
             >
               Description
             </button>
             <button
               @click="setActive('shipping')"
               :class="[
                 'text-center flex w-full justify-center py-3.5 px-2 border border-slate-100 rounded-lg text-description font-semibold shadow-md tracking-wide',
                 activeSection === 'shipping'
                   ? 'bg-ihh-midnight-gray text-white'
                   : 'bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray',
               ]"
             >
               Shipping & Returns
             </button>
           </div>
         </div>

         <div class="flex w-full justify-center">
            <div class="w-full md2:max-w-8xl">
           <div v-if="activeSection === 'shipping'">
             <div class="w-full max-w-8xl space-y-5 p-6">
               <div class="w-full text-start text-ihh-midnight-gray text-2xl font-semibold tracking-wide">
                 Shipping and Returns
               </div>
               <div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description leading-6">
                 Shipping cost is based on weight. Just add products to your cart and use the Shipping Calculator to view the different options. We offer free shipping on orders over $125 shipping to the lower 48 states. We want you to be 100% satisfied with your purchase. Most items in new condition can be returned or exchanged within 90 days of purchase. Read more about our shipping options <a href="#" class="text-ihh-dark-salmon underline">here</a> and returns <a href="#" class="text-ihh-dark-salmon underline">here</a>.
               </div>
             </div>
           </div>

           <div v-if="activeSection === 'description'" class="w-full max-w-8xl p-6">
            <!-- this is the description tag -->
            <Description />

           </div>
         </div>
        </div>

         <div class="flex w-full justify-center">
           <div class="mt-12 w-full max-w-8xl px-3">
             <!-- <AddedFilters class="w-full justify-start hidden md2:block"/> -->
             <div class="">
               <div class="flex w-full my-auto pb-2">
                 <div class="flex w-full text-start text-ihh-midnight-gray text-xl md2:text-2xl font-semibold tracking-wide whitespace-nowrap m-auto">
                   Image Gallery
                 </div>
                 <ImageScroller class="m-auto sm:flex md2:hidden"/>
               </div>

               <div class="flex w-full justify-start md2:justify-center">
                 <div class="grid grid-cols-2 xs:grid-cols-3 md2:grid-cols-4 gap-x-3 w-full min-w-fit md2:min-w-0">
                   <!-- <div class=""
                        v-for="product, a in products" :key="a"
                        :class="{'': [0,1].includes(a), 'hidden md2:block': [3].includes(a), 'hidden': ![0,1].includes(a), 'md2:block': ![0,1].includes(a)}"
                        > -->
                   <div v-for="(product, a) in products"
                        :key="a"
                        :class="{'block': a < 2, 'hidden xs:block': a >= 2 && a < 3, 'hidden md2:block': a >= 3 && a < 4, 'hidden': a >= 4}">
                     <div class="relative group flex w-full justify-center bg-ihh-light-lavendar rounded-xl h-full min-h-52 md2:min-h-77 max-h-77 items-center p-4 sm:p-8 md2:p-12 overflow-hidden shadow">
                       <img class="w-full object-center object-cover" :src="product.image" alt="products images">
                       <div class="absolute inset-0 flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100">
                         <!-- <button class="font-medium text-sm md2:text-base text-ihh-midnight-gray py-3 px-10 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon tracking-wide transition transform ease-in-out group-hover:-translate-y-10">{{ product.buttonText}}</button> -->
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>

         <Reviews />
         <!-- <Extras /> -->

       </div>
     </div>
   </div>
</template>

<!-- /images/ob-returns.svg -->
<script>
  import Description from './ihh-items/description.vue';
  import Stars from '../partials/stars.vue';
  import AboutService from './ihh-items/about-service.vue';
  import AddedFilters from './ihh-items/added-filters.vue';
//   import Extras from './ihh-items/related-products.vue';
  import ImageGallery from './ihh-items/image-gallery.vue';
  import ImageScroller from './ihh-items/image-scroller.vue';
  import Reviews from './ihh-items/reviews.vue';
  export default {
      components: { Stars, AddedFilters, ImageScroller, ImageGallery, AboutService, Reviews, Description },
        data() {
            return {
                showReview: false,
                currentIndex: 0,
                products: [],
                visibleProducts: [],
              selectedSponsorship: null,
              productInfo: [
                {
                  price: "50.00",
                  salesPrice: "28.00",
                  upcNumbers: "814802010323",
                  packages: "Each",
                  quantity: 5,
                },
                {
                  price: "239.00",
                  upcNumbers: "814802010324",
                  packages: "Pack of 10",
                  quantity: 1,
                },
                {
                  price: "460.00",
                  upcNumbers: "814802010729",
                  packages: "Case of 200",
                  quantity: 0,
                },
              ],
              products: [
                { image: "/images/Mini-LIner-0129.jpg" },
                { image: "/images/liner-2-0129.jpg" },
                { image: "/images/MINI-1-0129.jpg" },
                { image: "/images/tub-3-0129.jpg" },
                { image: "/images/big-white-pool-0129.jpg" },
                { image: "/images/water-birth-net-0129.jpg" },
                { image: "/images/water-birth-gloves-0129.jpg" },
                { image: "/images/generic-liner-2-0129.jpg" },
                { image: "/images/plastic-covering-removebg-preview-0129.jpg" },
                { image: "/images/shower-water-PVC-adapter.jpg" },
                { image: "/images/water-birth-gloves-0129.jpg" },
                // { image: '/images/category-image-water-birth-birth-pool-box-pools-0129.jpg' },
                // { image: '/images/category-image-water-birth-oasis-pools-0129.jpg' },
                // { image: '/images/mia-via-pool-0129.jpg' },
                // { image: '/images/earthside-0129.jpg' },
                // { image: '/images/category-image-water-birth-la-bassine-pools-0129.jpg' },
                // { image: '/images/category-image-water-birth-birth-pool-liners-0129.jpg' },
                // { image: '/images/category-image-water-birth-accessories-0129.jpg' },
                // { image: "/images/complete-birth-kit.jpg" },
                // { image: "/images/Rad-G-3Q-rt-0129.jpg" },
              ],
              selectedQuantity: 1,
              selectedImage: '',
              filtersApplied: false,
              activeSection: 'description',
              options: [
              {
            // title: "Fast Shipping",
            title: "Fast Shipping",
            image: "/images/ob-shipping.svg",
          },
          {
            title: "Satisfaction Guarantee",
            // title: "Fast Shipping",
            image: "/images/ob-smiley0129.svg",
          },
          {
            title: "Easy Returns",
            // title: "Fast Shipping",
            image: "/images/ob-returns.svg",
          },
        ],
        featured: [
              {
            title: "Email",
            image: "https://cfl-mango.s3.amazonaws.com/uploads/downloads/ob-envelope.svg",
          },
          {
            title: "Print",
            image: "/images/ob-print-0129.svg",
          },
          {
            title: "Share",
            image: "/images/ob-share-0129.svg",
          },
        ],
            }
          },
          methods: {
            filters() {
                this.filtersApplied = !this.filtersApplied;
            },
            setActive(section) {
              this.activeSection = section;
            },
            updateImage(image) {
                this.selectedImage = image;
            },
            scrollUp() {
              if (this.currentIndex > 0) {
                this.currentIndex -= 5;
                this.updateVisibleProducts();
              }
            },
            scrollDown() {
              if (this.currentIndex + 5 < this.products.length) {
                this.currentIndex += 5;
                this.updateVisibleProducts();
              }
            },
            updateVisibleProducts() {
              // Update the visibleProducts based on currentIndex
              this.visibleProducts = this.products.slice(this.currentIndex, this.currentIndex + 5);
            },
            selectPage(quantity) {
              this.selectedQuantity = quantity;
            },
          },
          computed: {
            percentage() {
              const price = this.productInfo[this.selectedQuantity - 1].price;
              const salesPrice = this.productInfo[this.selectedQuantity - 1].salesPrice;

              if (salesPrice) {
                const discount = ((price - salesPrice) / price) * 100;
                return discount.toFixed(0); // Rounds to the nearest whole number
              }
              return null; // No discount if salesPrice doesn't exist
            },
            isAddToBagDisabled() {
              return this.selectedQuantity === 0 || this.productInfo[this.selectedQuantity - 1].quantity <= 0;
            },
            addToBagButtonClass() {
              return [
                'text-sm md2:text-base text-ihh-midnight-gray py-2 px-10 w-full rounded-lg delay-100 transition tracking-wide whitespace-nowrap',
                {
                  'bg-ihh-midnight-gray text-ihh-white opacity-40 disabled:cursor-not-allowed': this.isAddToBagDisabled,
                  'bg-ihh-dark-salmon hover:bg-ihh-salmon': !this.isAddToBagDisabled,
                }
              ];
            },
            isAtTop() {
              return this.currentIndex <= 0;
            },
            isAtBottom() {
              return this.currentIndex + 5 >= this.products.length;
            },
            image() {
                return this.products[this.selectedfeature].image
            },
            sponserPrice() {
                if (this.selectedSponsorship == 'Platinum') return 3500
                if (this.selectedSponsorship == 'Gold') return 2000
                if (this.selectedSponsorship == 'Silver') return 1000
                return 0
            },
              visibleProducts() {
                  return this.products.slice(this.currentIndex, this.currentIndex + 5);
              }
          },
          mounted() {
            // Set the initial selected image if products array is not empty
            this.selectedImage = this.products.length > 0 ? this.products[0].image : '';
            this.updateVisibleProducts();
          }
        }
  </script>
